import { css } from '@emotion/react';
import { t } from 'i18n';

import { Divider, theme } from '../..';

const marginTop = css`
  margin-top: ${theme.spacing.md};
`;

type PassengerCountByType = {
  count: number;
  label: string;
};

type PassengerByName = {
  firstName: string;
  lastName: string;
};

type Props = {
  passengersByType?: PassengerCountByType[];
  passengerListByName?: PassengerByName[];
  displayDivider?: boolean;
};

const PassengerList = ({
  passengersByType,
  passengerListByName,
}: {
  passengersByType?: PassengerCountByType[];
  passengerListByName?: PassengerByName[];
}) => {
  if (passengerListByName) {
    return (
      <>
        {passengerListByName.map(({ firstName, lastName }) => (
          <div key={`${firstName}-${lastName}`}>{`${firstName} ${lastName}`}</div>
        ))}
      </>
    );
  }

  if (passengersByType) {
    return (
      <>
        {passengersByType.map(({ count, label }) => (
          <div key={label}>{`${count} ${label}`}</div>
        ))}
      </>
    );
  }

  return null;
};

export const PassengerCount = ({ passengersByType, passengerListByName, displayDivider = true }: Props) => {
  return (
    <div>
      {displayDivider && <Divider css={marginTop} />}
      <h4 css={marginTop}>{t('common:travelers')}</h4>
      <PassengerList passengersByType={passengersByType} passengerListByName={passengerListByName} />
    </div>
  );
};
